import { installMarketingScriptBootstrap } from './marketingScriptBootstrap';

installMarketingScriptBootstrap();
